import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
}
export const getContactList = createAsyncThunk(
    "getContactList",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/hummingbird/contact/get-contact-list?page=${body.page}&search=${body.search}`);
            return response.data;

        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)



export const ContactsSlice = createSlice({
    name: 'ContactsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getContactList.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getContactList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload
            state.count = action?.payload?.count;
        })
        builder.addCase(getContactList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
    },

})

export default ContactsSlice.reducer;